import * as React from "react";
import Typography from "@mui/material/Typography";
import EditPopUpAdmin from "./parteAnexo/EditPopUpAdmin";
import { connect, useDispatch, useSelector } from "react-redux";
import AnexosEdit from "./AnexosEdit";

import { hosting, mapStateToProps } from "../models/buscar";
import axios from "axios";
import { CLIENTES_REDUX } from "../../../redux/constanst";

function EditUser(props) {
  const { actualizarLista } = useSelector((state) => state.userState);
  // eslint-disable-next-line no-unused-vars
  const [empresa, setEmpresa] = React.useState([]);
  const dispatch = useDispatch();
  const [anexos, setAnexos] = React.useState([]);
  React.useEffect(() => {
    axios
      .get(`${hosting}/mimegacall/api/select_usuarios.php`)
      .then((response) => {
        const arr = Object.values(response.data);

        setEmpresa(arr);
        dispatch({ type: CLIENTES_REDUX, clientesRedux: arr });
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .get(`${hosting}/mimegacall/api/select_anexos_all.php`)
      .then((response) => {
        setAnexos(Object.values(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualizarLista]);

  const anexosAmbos2 = [
    {
      item: 0,
      name: "Anexos",
      lista: anexos,
    },
  ];

  return (
    <div>
      {anexosAmbos2.map((solicitud) => {
        return (
          <>
            <Typography
              style={{
                marginLeft: 20,
                fontSize: 18,
                alignItems: "left",
                justifyContent: "left",
                textAlign: "left",
                borderRadius: 10,
                padding: 5,
                fontWeight: "600",
              }}
            >
              {solicitud.name}
            </Typography>
            <div
              style={{
                width: "100%",
                textAlign: "right",
              }}
            >
              <EditPopUpAdmin
                style={{
                  height: 30,
                  marginLeft: 1,
                  marginRight: 1,
                  marginBottom: 1,
                  backgroundColor: "orange",
                }}
                btnLabel={"Crear anexo"}
              />
            </div>
            <AnexosEdit data={anexos} />
          </>
        );
      })}
    </div>
  );
}

export default connect(mapStateToProps, null)(EditUser);
